import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IAmortization, IRealEstateClass } from './interfaces';

export const getAmortizationList = (params: IDynamicTableParams): Promise<IAmortization[]> => {
  return instance()
    .post('/calculatorTariff/amortization/list', params)
    .then((response) => response.data);
};

export const getAmortizationListAll = (): Promise<IAmortization[]> => {
  return instance()
    .post('/calculatorTariff/amortization/listAll')
    .then((response) => response.data);
};

export const getAmortizationAvailableColumns = (): Promise<IAvailableColumnModel[]> => {
  return instance()
    .post('/calculatorTariff/amortization/availableColumns')
    .then((response) => response.data);
};

export const getAmortizationAvailableGroupColumns = (): Promise<IAvailableGroupColumnModel[]> => {
  return instance()
    .post('/calculatorTariff/amortization/availableGroupColumns')
    .then((response) => response.data);
};

export const loadAmortization = (amortizationId: number) => {
  return instance()
    .get<IAmortization>('/calculatorTariff/amortization/load/' + amortizationId)
    .then((response) => response.data);
};

export const createAmortization = (amortization: IAmortization) => {
  return instance()
    .post<IAmortization>('/calculatorTariff/amortization/save', amortization)
    .then((response) => response.data);
};

export const updateAmortization = (amortization: IAmortization) => {
  return instance()
    .post<IAmortization>(`/calculatorTariff/amortization/${amortization.amortizationId}/update`, amortization)
    .then((response) => response.data);
};

export const deleteAmortization = (amortizationId: number) => {
  return instance()
    .post('/calculatorTariff/amortization/archive', { amortizationId })
    .then((response) => response.data);
};

export const recoverAmortization = (amortizationId: number) => {
  return instance()
    .post('/calculatorTariff/amortization/recover', { amortizationId })
    .then((response) => response.data);
};

export const getRealEstateClassListAll = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IRealEstateClass[]>('/calculatorTariff/realEstateClass/search', config)
    .then((response) => response.data);
};
